export interface ModalitiesTypes {
  id: number;
  sigla: string;
  nome: string;
}

export const Modalities: Array<ModalitiesTypes> = [
  {
    id: 1,
    sigla: 'AP',
    nome: 'Audiência Pública',
  },
  {
    id: 2,
    sigla: 'CE',
    nome: 'Compra Eletrônica',
  },
  {
    id: 3,
    sigla: 'CP',
    nome: 'Coleta de Preços',
  },
  {
    id: 4,
    sigla: 'CR',
    nome: 'Concorrência',
  },
  {
    id: 5,
    sigla: 'CS',
    nome: 'Convite Shopping',
  },
  {
    id: 6,
    sigla: 'CV',
    nome: 'Convite',
  },
  {
    id: 7,
    sigla: 'DL',
    nome: 'Dispensa de Licitação',
  },
  {
    id: 8,
    sigla: 'LE',
    nome: 'Leilão',
  },
  {
    id: 9,
    sigla: 'SM',
    nome: 'Sem Modalidade',
  },
  {
    id: 10,
    sigla: 'PE',
    nome: 'Pregão Eletrônico',
  },
  {
    id: 11,
    sigla: 'PR',
    nome: 'Pregão Presencial',
  },
  {
    id: 12,
    sigla: 'RDC',
    nome: 'Regime Diferenciado de Contratação',
  },
  {
    id: 13,
    sigla: 'TP',
    nome: 'Tomada de Preço',
  },
];
